import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Services from './components/Services';
import Machines from './components/Machines';
import Strengths from './components/Strengths';
import Contact from './components/Contact';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    let strengthsAnimated = false;

    const triggerStrengths = () => {
      if (strengthsAnimated) return;
      strengthsAnimated = true;

      const items = document.querySelectorAll('.strength-item');
      items.forEach((item, index) => {
        setTimeout(() => {
          item.classList.add('animate');
        }, index * 100);
      });
    };

    if (typeof window.IntersectionObserver === 'undefined') {
      window.addEventListener('scroll', handleScroll);
      handleScroll();

      setTimeout(() => {
        const strengthItems = document.querySelectorAll('.strength-item');
        const anyVisible = Array.from(strengthItems).some(item => {
          const rect = item.getBoundingClientRect();
          return rect.top < window.innerHeight;
        });
        if (anyVisible) triggerStrengths();
      }, 300);

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');

          if (entry.target.classList.contains('strength-item')) {
            triggerStrengths();
          }
        }
      });
    }, observerOptions);

    document.querySelectorAll('.fade-in, .service-card, .strength-item').forEach(el => {
      observer.observe(el);
    });

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    setTimeout(() => {
      const strengthItems = document.querySelectorAll('.strength-item');
      const anyVisible = Array.from(strengthItems).some(item => {
        const rect = item.getBoundingClientRect();
        return rect.top < window.innerHeight;
      });
      if (anyVisible) triggerStrengths();
    }, 300);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    }
    setMenuOpen(false);
  };

  return (
    <div className="font-poppins text-text-light bg-primary-dark overflow-x-hidden">
      <div className="bg-animation" aria-hidden="true"></div>

      <Navbar
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        scrollToSection={scrollToSection}
        scrolled={scrolled}
      />
      <main>
        <Hero scrollToSection={scrollToSection} />
        <Stats />
        <Services />
        <Machines />
        <Strengths />
        <Contact />
      </main>
    </div>
  );
}

export default App;
